import { Mapper } from '../../../../base/utils/mapper';
import { TypeBirthModel } from '../../../../domain/models/consult/type-birth.model';
import { TypeBirthEntity } from '../entities/type-birth.entity';

export class TypeBirthImplementationRepositoryMapper extends Mapper<TypeBirthEntity,TypeBirthModel> {
  mapFrom(param: TypeBirthEntity): TypeBirthModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: TypeBirthModel): TypeBirthEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
